import { render, staticRenderFns } from "./VantShareChangePop.vue?vue&type=template&id=080d69c8&"
import script from "./VantShareChangePop.vue?vue&type=script&lang=js&"
export * from "./VantShareChangePop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports